module.exports = __webpack_public_path__ + "static/media/logo.4cd76959.png";